var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto","width":"100%","text-align":"center"}},[_c('div',{staticClass:"elevation-0 theme-button-custom"},[_vm._t("actionButtons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }